import React from 'react'
import { Link } from 'react-router-dom'

function Navbar() {
  return (
    <>
        <nav className="navbar nav justify-content-end topnavbar">
          <Link className="nav-link btn" to="/signup">Signup</Link>
          <Link className="nav-link btn btn-light text-dark" to='/login'>Login</Link>
        </nav>
    </>
  )
}

export default Navbar